var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chevronUp_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M16 16H0V0h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chevronUp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M8 6.033q.132 0 .25.042.116.042.216.142L11.55 9.3q.183.183.174.459a.65.65 0 0 1-.191.458.63.63 0 0 1-.467.183.63.63 0 0 1-.466-.183L8 7.617l-2.617 2.616a.6.6 0 0 1-.459.176.65.65 0 0 1-.458-.192.63.63 0 0 1-.183-.467q0-.283.183-.467l3.067-3.066a.6.6 0 0 1 .217-.142.7.7 0 0 1 .25-.042"
  }))));
};
export default SvgChevronUp;